export const ENDPOINT = process.env.NEXT_PUBLIC_API_ENDPOINT as string;
export const TEST_EVENT_CODE = process.env
  .NEXT_PUBLIC_TEST_EVENTS_CODE as string;
export const ENDPOINT_MICROSERVICE = process.env
  .NEXT_PUBLIC_API_MICROSERVICE_ENDPOINT as string;
